function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "C09E3644-EE48-4871-8DA2-669B43240218");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kronos_Style-guide_3",
  transform: "translate(-598.000000, -344.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(100.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(0.000000, 144.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(0.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(120.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "24px_68",
  transform: "translate(378.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M19.7892857,8.42857143 L16.3857143,8.42857143 C15.887924,6.66893481 15.0237974,5.03439669 13.85,3.63214286 C16.4695467,4.21699177 18.6660721,5.9908544 19.7892857,8.42857143 L19.7892857,8.42857143 Z M11.9607143,20.2357143 L11.9607143,20.2357143 C10.6510033,18.9308962 9.67256492,17.3315965 9.10714286,15.5714286 L14.8928571,15.5714286 C14.3264018,17.3319458 13.3467197,18.9312768 12.0357143,20.2357143 C12.0133046,20.2518086 11.983124,20.2518086 11.9607143,20.2357143 Z M8.74642857,14.1428571 C8.48450547,12.7262914 8.48450547,11.2737086 8.74642857,9.85714286 L15.2535714,9.85714286 C15.5154945,11.2737086 15.5154945,12.7262914 15.2535714,14.1428571 L8.74642857,14.1428571 Z M3.42856099,12 C3.4274379,11.2770708 3.51865223,10.5569577 3.7,9.85714286 L7.29642857,9.85714286 C7.06322501,11.2761971 7.06322501,12.7238029 7.29642857,14.1428571 L3.7,14.1428571 C3.51865223,13.4430423 3.4274379,12.7229292 3.42856099,12 L3.42856099,12 Z M12,3.75 C12.0126228,3.74502517 12.026663,3.74502517 12.0392857,3.75 C13.3509305,5.05888672 14.329494,6.66329005 14.8928571,8.42857143 L9.10714286,8.42857143 C9.67359817,6.66805422 10.6532803,5.0687232 11.9642857,3.76428571 C11.9740114,3.7552667 11.9867372,3.75017638 12,3.75 Z M16.7035714,9.85714286 L20.3,9.85714286 C20.6619702,11.2627854 20.6619702,12.7372146 20.3,14.1428571 L16.7035714,14.1428571 C16.936775,12.7238029 16.936775,11.2761971 16.7035714,9.85714286 Z M10.15,3.63214286 C8.97754438,5.03529784 8.11357624,6.66953616 7.61428571,8.42857143 L4.21071429,8.42857143 C5.33392793,5.9908544 7.53045329,4.21699177 10.15,3.63214286 L10.15,3.63214286 Z M4.21071429,15.5714286 L7.61428571,15.5714286 C8.11207597,17.3310652 8.97620259,18.9656033 10.15,20.3678571 C7.53045329,19.7830082 5.33392793,18.0091456 4.21071429,15.5714286 L4.21071429,15.5714286 Z M13.8535714,20.3678571 C15.0247498,18.9643845 15.8874894,17.3301685 16.3857143,15.5714286 L19.7892857,15.5714286 C18.6660721,18.0091456 16.4695467,19.7830082 13.85,20.3678571 L13.8535714,20.3678571 Z",
  id: "Shape",
  fill: "currentColor",
  fillRule: "nonzero"
}))))))));

var SvgWorld = function SvgWorld(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorld, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/world.0ca04788.svg";
export { ForwardRef as ReactComponent };